<template>
  <transition name="cube-picker-fade">
    <cube-popup
      v-show="visible"
      ref="myModal"
      type="modal"
      class="fullpage-modal"
      :mask-closable="maskClosable || true"
      @touchmove.prevent
      @mask-click="maskClick"
    >
      <transition name="cube-picker-move">
        <div
          v-show="visible"
          class="cube-picker-panel cube-safe-area-pb"
          @click.stop
        >
          <div class="cube-picker-choose border-bottom-1px">
            <div
              v-if="title"
              class="cube-picker-title-group"
            >
              <h1
                class="cube-picker-title"
                v-html="title"
              />
              <h2
                v-if="subtitle"
                class="cube-picker-subtitle"
                v-html="subtitle"
              />
            </div>
            <slot
              name="title"
            />
          </div>

          <div class="cube-picker-content">
            <!-- <div
              ref="wrapper"
              class="wrapper"
            > -->
            <slot name="content" />
            <!-- </div> -->
          </div>

          <div
            v-if="footer"
            class="cube-picker-footer footer form-btn-box"
          >
            <cube-button
              class="cancel-btn cube-btn-light"
              @click="cancel"
            >
              {{ _cancelTxt }}
            </cube-button>
            <cube-button
              class="confirm-btn cube-btn-primary"
              type="submit"
              @click="confirm"
            >
              {{ _confirmTxt }}
            </cube-button>
          </div>
        </div>
      </transition>
    </cube-popup>
  </transition>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    cancelTxt: {
      type: String,
      default: ''
    },
    confirmTxt: {
      type: String,
      default: ''
    },
    footer: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    _cancelTxt () {
      return this.cancelTxt || this.$t('message["896"]')
    },
    _confirmTxt () {
      return this.confirmTxt || this.$t('message["915"]')
    }
  },
  methods: {
    maskClick () {
      this.maskClosable && this.cancel()
    },
    hide () {
      this.$emit('update:visible', false)
    },
    cancel () {
      this.hide()
      this.$emit('cancel')
    },
    confirm () {
      this.hide()
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
.fullpage-modal ::v-deep {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  .cube-picker-panel {
    height: 100%;
    background-color: #f5f5f5;
  }
  .cube-picker-choose {
    height: auto;
  }
  .cube-picker-title-group {
    padding: 20px 12px 12px;
    text-align: left;
  }
  .cube-picker-title {
    font-size: 14px;
  }
  .cube-popup-container .cube-popup-content {
    width: 100% !important;
    height: 100% !important;
  }
  .cube-picker-content {
    top: 0;
    height: 100%;
    text-align: left;
  }
  .ant-upload.ant-upload-select {
    float: right;
    margin-top: 6px;
  }
  .ant-upload-list-item {
    display: flex;
  }
}
</style>
